import React, {Component, Fragment} from "react";
import {connect} from "react-redux";
import styled from "styled-components";
import {Heading, Text} from "components/styled";
import {ProgressBar} from "../../visualization";
import {
    commonLocalization,
    number,
    currency,
    helpTextLocalization
} from "localization";
import { images } from "../../../config/index";

const defaultData = [
    {
        budget: 0,
        expenditure: 0
    }
];

class ProjectBudgetExpChart extends Component {
    constructor() {
        super();
        this.state = {
            parentWidth: 0,
            mouseValue: 0
        };
        this.ref = React.createRef();
    }

    componentDidMount() {
        this.fitParentContainer();
        window.addEventListener("resize", this.fitParentContainer);
    }

    getData = data => {
        if (!data || !Object.keys(data).length) return null;

        return [
            {
                budget: data.total.budget.value,
                expenditure: data.total.expenditure.value
            }
        ];
    };

    getFragment(selectedWard, selectedLanguage) {
        if (selectedWard === "all") return null;

        if (selectedLanguage === "en") {
            return (
                <Fragment>
                    <span className="opacity-70">for</span> <strong>Ward {number(selectedWard)}</strong>
                </Fragment>
            );
        }
        return (
            <Fragment>
                <strong className="opacity-100">वडा {number(selectedWard)}</strong> <span className="opacity-70">का लागि</span>
            </Fragment>
        );
    }

    handleTooltipData = mouseValue => {
        this.setState({mouseValue});
    };
    fitParentContainer = () => {
        const {parentWidth} = this.state;
        
        if (!this.ref.current) return;

        const currentParentWidth =
            this.ref.current && this.ref.current.getBoundingClientRect().width;

        const shouldResize = parentWidth !== currentParentWidth;
        if (shouldResize) {
            this.setState({
                parentWidth: currentParentWidth
            });
        }
    };

    render() {
        const {parentWidth, mouseValue} = this.state;
        const margin = {
            top: 45,
            right: 0,
            bottom: 70,
            left: 0
        };
        const {selectedWard, overall, ward_wise, selectedLanguage} = this.props;
        const {progressBarTitle, expenditure, nrs} = commonLocalization[
            selectedLanguage
            ];
        const {progressBar: progressBarHelpText} = helpTextLocalization[
            selectedLanguage
            ];

        let data = selectedWard === "all" ? overall : ward_wise[selectedWard];

        data = this.getData(data) || defaultData;

        const height = 140;
        const width = parentWidth ? parentWidth - 32 : 0;

        const tooltipPosition = height

        return (
            <ChartsBlock
                className="charts-block budget-exp flex flex-col"
                lang={selectedLanguage}
            >
                <Heading.h2 uppercase style={{marginBottom: 8}} className="flex items-center">
                    <Text.span className="help-text">
                        <Text.span className="help-text__icon"><img className="help-icon" height={18} width={18} src={images.icons.help} alt="help" /></Text.span>
                        <Text.span className="help-text__content tooltip">
                            <Text.span className="tooltip-arrow">arrow</Text.span>
                            {progressBarHelpText}
                        </Text.span>
                    </Text.span>
                    <Text.span>
                        {selectedLanguage === "en" && <span className="opacity-70">{progressBarTitle} </span>}
                        {this.getFragment(selectedWard, selectedLanguage)}
                        {selectedLanguage === "np" && <span className="opacity-70"> {progressBarTitle}</span>}
                    </Text.span>
                </Heading.h2>
                <ChartSection className="card--chart flex-1 flex items-center"
                              innerRef={this.ref}
                              mouseValue={mouseValue}
                              tooltipPosition={tooltipPosition}
                >
                    <div className="tooltip">
                        <div className="tooltip-arrow bottom"/>
                        <div>
                            <span>{nrs} </span>
                            <span className="">
                <strong>{currency(data[0].expenditure.toFixed(0))}</strong>
              </span>
                            <div className="">{`(${expenditure})`}</div>
                        </div>
                    </div>
                    <ProgressBar
                        {...{
                            width,
                            height,
                            margin,
                            data
                        }}
                        onMouseMove={this.handleTooltipData}
                    />
                </ChartSection>
            </ChartsBlock>
        );
    }
}

const ChartsBlock = styled.div`
  h2 {
    font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
    > span:last-child {
      font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
    }
  }
  text {
    font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
  }
`;

const ChartSection = styled.div`
  font-size: 12px;
  position: relative;
  .tooltip {
    visibility: ${props => (props.mouseValue === 0 ? "hidden" : "visible")};
    position: absolute;
    left: ${props => `${props.mouseValue}px`};
    bottom: ${props => `${props.tooltipPosition + 15}px`};
    transform: translateX(-50%);
  }
  .budget-bar-group {
    rect {
      fill: #3b4555;
    }
    text {
      fill: var(--color-theme-1);
    }
    text:nth-of-type(2) {
      opacity: 0.5;
    }
  }
  .expenditure-bar-group {
    rect:first-of-type {
      fill: #ecc417;
    }
    rect:nth-of-type(2) {
      fill: var(--color-theme-1);
      opacity: 0.3;
    }
    text {
      fill: var(--color-theme-1);
    }
    text:nth-of-type(2) {
      opacity: 0.5;
    }
  }
`;

const mapStateToProps = state => ({
    selectedWard: state.projectsStatsReducers.selectedWard,
    overall: state.projectsStatsReducers.data.data.overall,
    ward_wise: state.projectsStatsReducers.data.data.ward_wise,
    selectedLanguage: state.localizationReducers.selectedLanguage
});
export default connect(mapStateToProps)(ProjectBudgetExpChart);



// WEBPACK FOOTER //
// ./src/components/layouts/projectBudgetExpChart/projectBudgetExpChart.js